module.exports = __webpack_public_path__ + "static/media/Venomizer.9ba4a142.png";